import { ItemAction } from '@jotta/grpc-js-client/fileService'

import { isBackupOriginApiPath } from '../FileRoute/utils/apiPathToRouteContext'

export function trashContainsUnrestorableBackupItem(paths: readonly string[]) {
  return paths.some(isBackupOriginApiPath)
}

export function isRestorableTrashItem(item: {
  path: string
  actionList: readonly ItemAction[]
}) {
  return (
    item.actionList.includes(ItemAction.RESTORE) &&
    !isBackupOriginApiPath(item.path)
  )
}

export function selectionOffersRestore(
  items: readonly { path: string; actionList: readonly ItemAction[] }[],
) {
  return items.some(isRestorableTrashItem)
}
